import { Grid, Typography, makeStyles } from "@material-ui/core";

import { PowerAssetIcon } from "../../../PowerAssetIcon";
import { ActionButtonsGroup } from "../../../../../components/buttonsGroup/ActionButtonsGroup";
import { COLORS } from "../../../../../theme/colors";
import { IconButtonMui } from "../../../../../components/base/IconButtonMui";
import { Close as CloseIcon } from "@material-ui/icons";

const useStyles = makeStyles(() => ({
  label: {
    textTransform: "uppercase",
    lineHeight: "22px",
  },
  address: {
    lineHeight: "14px",
  },
}));

export const Header = ({ data, setIsList }) => {
  const classes = useStyles();

  return (
    <Grid container alignItems="center">
      <Grid item>
        <PowerAssetIcon type={data.type} />
      </Grid>
      <Grid item>
        <Typography variant="body1" style={{ fontWeight: 700 }} className={classes.label}>
          {data.type}
        </Typography>
        <Typography variant="body1" className={classes.address}>
          {data.building.address}
        </Typography>
      </Grid>
      <Grid item style={{ marginLeft: "auto", alignSelf: "baseline" }}>
        <Grid container alignItems="center" spacing={3}>
          <Grid item>
            <ActionButtonsGroup hideIntegrateBtn />
          </Grid>
          <Grid item>
            <IconButtonMui
              color={COLORS.white}
              backgroundColor={COLORS.purple}
              width={32}
              height={32}
              onClick={() => setIsList(true)}
            >
              <CloseIcon />
            </IconButtonMui>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
